import { BRAND } from "../lib/content";
import { EmailSignup } from "./EmailSignup";
import { FadeUp } from "./Reveal";
import { CornerWebs } from "./CornerWebs";
import { FlameInitial } from "./FlameInitial";

export const JoinSection = ({ source = "website", frame = "border-y border-ember/25 py-24 md:py-32" }) => (
  <section id="join" data-testid="join-section" className={`relative overflow-hidden bg-ink ${frame}`}>
    <CornerWebs />
    <div className="pointer-events-none absolute left-1/2 top-1/2 h-[420px] w-[420px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-flame opacity-20 blur-[130px]" />
    <div className="relative z-10 mx-auto max-w-3xl px-6 text-center">
      <img src={BRAND.star} alt="" className="mx-auto mb-8 h-10 w-10 opacity-80" />
      <FadeUp>
        <p className="font-gothic text-xs uppercase tracking-[0.35em] text-flame">Join the Journey</p>
        <h2 className="mt-6 font-display text-4xl font-light leading-tight tracking-tight text-white sm:text-5xl">
          <FlameInitial letter="B" size="0.86em" className="mr-[0.01em] translate-y-[2px]" />e first to know when the{" "}
          <span
            style={{
              backgroundImage: "linear-gradient(90deg, #FFD700 0%, #FF7A1A 50%, #E2341E 100%)",
              WebkitBackgroundClip: "text",
              backgroundClip: "text",
              color: "transparent",
            }}
          >
            Kickstarter launches.
          </span>
        </h2>
        <p className="mx-auto mt-6 max-w-xl font-body text-base leading-relaxed text-white/60">
          Join the Tattooed Abroad list and get notified when the campaign goes live, when episodes
          release, and when there are major updates.
        </p>
      </FadeUp>
      <FadeUp delay={0.15} className="mx-auto mt-10 max-w-xl">
        <EmailSignup source={source} />
      </FadeUp>
    </div>
  </section>
);
